import { render, staticRenderFns } from "./LeadsStateChip.vue?vue&type=template&id=dc255104&scoped=true&"
import script from "./LeadsStateChip.vue?vue&type=script&lang=js&"
export * from "./LeadsStateChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc255104",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
